import React from 'react';

import OtherHousesOutlinedIcon from '@mui/icons-material/OtherHousesOutlined';
import { Typography } from '@mui/material';

import { MapMarker } from '@kamernet/core/ApiClient/Kamernet';

import styles from './RoomMarker.module.css';
import { MapProps } from './types';

const listingsCount = (listings: MapMarker[]) => {
  if (Array.isArray(listings)) {
    return listings.reduce((n, { count }) => n + count, 0);
  }
  return listings;
};

export type MarkerProps = {
  key: string;
  lat: number;
  lng: number;
  listings: MapMarker[];
  isSelected: boolean;
  onClick: (latitude: number, longitude: number) => void;
} & Partial<MapProps>;
export const ListingMarker = ({
  isSelected,
  listings,
  key,
  lat,
  lng,
  onClick,
}: MarkerProps) => {
  const totalListingsInLocation = listingsCount(listings);

  const clickHandler = React.useCallback(() => {
    onClick(lat, lng);
  }, [lat, lng, onClick]);

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    <div
      key={key}
      className={isSelected ? styles.markerActive : styles.marker}
      onClick={clickHandler}
    >
      <OtherHousesOutlinedIcon fontSize="small" />
      <Typography variant="body3Bold" className={styles.markerCount}>
        {totalListingsInLocation > 1 ? totalListingsInLocation : 1}
      </Typography>
    </div>
  );
};
